import i18n from 'i18next';
import backend from 'i18next-xhr-backend';

// Use current import after mingrate v9 -> v10
const initReactI18next = require('react-i18next');

i18n
  .use(backend)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'en',
    lng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      wait: true,
      useSuspense: false,
    },

    ns: ['common', 'validation'],
    defaultNS: 'common',
  });

export default i18n;

export const fr = i18n.getFixedT('fr');

export const en = i18n.getFixedT('en');

export const getTByLang = code => {
  if (!i18n.hasResourceBundle(code)) {
    i18n.loadLanguages(code);
  }
  return code === 'fr' ? fr : en;
};
